import { getToken } from '@/utils/auth'


const noAuthRoutes = [
    'Home',
    'Login',
    'Forgot Password',
    'Verify Email Address',
    'Results',
    'Journey',
    'PrivacyPolicy',
    'HearMore',
    'Contact',
    'Cookie',
    'SiteMap',
    'Statement',
    'Register',
]

const authRoutes = [
    'Account',
    'Edit',
    'Searches',

];

export default (to, from, next) => {
    if (getToken() && noAuthRoutes.includes(to.name)) {
        next()
    } else if (!getToken() && authRoutes.includes(to.name)) {
        next({ name: 'Login' })
    } else {
        next()
    }
}
